<template>

  <div>
    <marquee>
      <h4
        v-if="infoStudentAboutToExpired != null"
        style="color: red"
      >
        Cảnh báo, sắp hết hạn thời gian bảo lưu {{ getFormattedDate(infoStudentAboutToExpired.expireDate) }}!
      </h4>
    </marquee>
    <b-row class="match-height">
      <b-col
        sm="12"
        md="12"
        lg="4"
      >
        <b-card no-body>
          <b-card-header class="bg-success text-white">
            <div class="d-flex align-items-center">
              <feather-icon
                size="42"
                class="mr-1"
                icon="TargetIcon"
              />
              <b-card-title class="ml-25 text-uppercase text-white">
                Kết quả học tập
              </b-card-title>
            </div>
          </b-card-header>
          <b-card-body class="p-1 font-medium-2">
            <b-card-text>
              Điểm TB học kỳ gần nhất: <strong class="text-success">
              {{ (studentCgpaInfo.gpaFourth !== null && studentCgpaInfo.gpaFourth ) ? studentCgpaInfo.gpaFourth : 'Chưa có' }}
              {{ (studentCgpaInfo.gpaTenth !== null && studentCgpaInfo.gpaTenth ) ? ' (' + studentCgpaInfo.gpaTenth + ')' : '' }}
            </strong>
            </b-card-text>
            <b-card-text>
              Điểm TB tích lũy: <strong class="text-success">
              {{ (studentCgpaInfo.cgpaFourth !== null && studentCgpaInfo.cgpaFourth) ? studentCgpaInfo.cgpaFourth : 'Chưa có' }}
              {{ (studentCgpaInfo.cgpaTenth !== null && studentCgpaInfo.cgpaTenth) ? ' (' + studentCgpaInfo.cgpaTenth + ')' : '' }}
            </strong>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        sm="12"
        md="12"
        lg="4"
      >
        <b-card no-body>
          <b-card-header class="bg-warning text-white">
            <div class="d-flex align-items-center">
              <feather-icon
                size="42"
                md-size="32"
                class="mr-1"
                icon="AwardIcon"
              />
              <b-card-title class="ml-25 text-white">
                TRÌNH ĐỘ SINH VIÊN
              </b-card-title>
            </div>
          </b-card-header>
          <b-card-body class="p-1 font-medium-2">
            <b-card-text>
              <strong class="text-success">{{
                  studentCgpaInfo.schoolYearLevelName || '---'
                }}</strong> <span>({{ studentCgpaInfo.totalCredit || '---' }} Tín chỉ tích lũy)</span>
            </b-card-text>
            <b-card-text>
              <span> Cảnh báo: </span><strong class="text-danger"> {{ alertString }}</strong>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        sm="12"
        md="12"
        lg="4"
      >
        <b-card no-body>
          <b-card-header :class="`text-white bg-${(studentInfoReception.status<2 && studentInfoReception.total>0)?'danger':'info'}`">
            <div class="d-flex align-items-center">
              <feather-icon
                size="42"
                class="mr-1"
                icon="DollarSignIcon"
              />
              <b-card-title class="ml-25 text-white">
                HỌC PHÍ
              </b-card-title>
            </div>
          </b-card-header>
          <b-card-body class="p-1 font-medium-2">
            <b-card-text>
              Tổng đã nộp: <strong class="badge badge-primary">{{ showCurrencyVND((studentInfoReception.status===2)?studentInfoReception.amount:0) }}</strong>
            </b-card-text>
            <b-card-text>
              Tổng chưa nộp: <strong class="badge badge-danger">{{ showCurrencyVND((studentInfoReception.status===1)?studentInfoReception.total:0) }}</strong>
              <b-button
                v-if="studentInfoReception.status < 2 && studentInfoReception.total>0"
                variant="success"
                size="sm"
                class="float-md-right ml-1 ml-md-0"
                title="Thanh toán"
                @click="openPaymentTransaction"
              >
                <b-spinner
                  v-if="isLoading"
                  small
                />
                <feather-icon
                  v-if="!isLoading"
                  icon="CreditCardIcon"
                /> Thanh toán
              </b-button>
            </b-card-text>
            <b-card-text>
              Miễn giảm: <strong class="badge badge-success">{{ showCurrencyVND(studentInfoReception.total_exemption) }}</strong>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card no-body>
          <b-card-header class="bg-primary text-white">
            <div class="d-flex align-items-center">
              <feather-icon
                size="24"
                class="mr-1"
                icon="CalendarIcon"
              />
              <b-card-title class="ml-25 text-white">
                THỜI KHÓA BIỂU
              </b-card-title>
            </div>
          </b-card-header>
          <b-card-body class="p-1 ">
            <viewSchedule />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getUser } from '@/auth/utils'
import {
  BButton, BCard, BCardBody, BCardHeader, BCardText, BCardTitle, BCol, BRow, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import viewSchedule from '@/views/study/schedule/StudentSchedule.vue'
import api from './api'

export default {
  name: 'Dashboard',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardHeader,
    BCardBody,
    BCardText,
    BButton,
    BSpinner,
    viewSchedule,
  },
  data() {
    return {
      isLoading: false,
      filter: {
        code: '',
        name: '',
      },
      studentInfoReception: {},
      studentRating: {
        schoolYearLevelName: '',
        totalCredit: 0,
      },
      oldPassword: '',
      newPassword: '',
      reNewPassword: '',
      classId: 0,
      courseId: 0,
      courseSemesterId: 0,
      user: getUser(),
      infoReceiptRequest: {},
      infoRePortRequest: {},
    }
  },
  computed: {
    ...mapGetters({
      infoStudentAboutToExpired: 'student/infoStudentExpired',
      infoReception: 'student/infoReception',
    }),
    studentCgpaInfo() {
      const { programmes, portalProgrammeId } = this.user
      return programmes.find(element => element.id === portalProgrammeId)
    },
    alertString() {
      let alertString = 'Không'
      const { programmes, portalProgrammeId } = this.user
      const selectedProgramme = programmes.find(element => element.id === portalProgrammeId)
      // eslint-disable-next-line eqeqeq
      alertString = (selectedProgramme.academicWarned == 1) ? 'Bạn đã bị cảnh báo học tập kỳ này!' : alertString
      // eslint-disable-next-line eqeqeq
      alertString = (selectedProgramme.isSuspended == 1) ? 'Bạn đã bị buộc thôi học!' : alertString
      return alertString
    },
  },
  async created() {
    await this.getInitData()
  },

  methods: {
    ...mapActions({
      changePassword: 'student/changePassword',
      getInfoStudentAboutToExpired: 'student/getInfoStudentAboutToExpired',
      getInfoReception: 'student/getInfoReception',
    }),
    getStudentInfoReception() {
      const studentInfoReception = { ...this.infoReception[0] }
      for (let i = 1; i < this.infoReception.length; i++) {
        studentInfoReception.total_exemption += this.infoReception[i].total_exemption
        studentInfoReception.amount += this.infoReception[i].amount
        studentInfoReception.total += this.infoReception[i].total
        studentInfoReception.status = (this.infoReception[i].status > studentInfoReception.status) ? this.infoReception[i].status : studentInfoReception.status
      }
      return studentInfoReception
    },
    async getInitData() {
      const { programmes, portalProgrammeId } = this.user
      const found = programmes.find(element => element.id === portalProgrammeId)

      this.infoReceiptRequest = {
        day_start: '',
        day_end: '',
        class_id: (found) ? found.classId : 0,
        course_id: (found) ? found.courseId : 0,
        student_class_id: (found) ? found.studentClassId : 0,
        semester_id: (found) ? found.courseSemesterId : 0,
      }

      await Promise.all([
        this.getInfoStudentAboutToExpired({ studentId: this.user.studentId }),
        this.getInfoReception(this.infoReceiptRequest),
      ])
      this.studentInfoReception = this.getStudentInfoReception()
    },

    async handleChangePassword() {
      if (this.newPassword !== this.reNewPassword) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Nhập lại mật khẩu mới chưa khớp',
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
        return
      }
      const body = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      }
      try {
        const res = await this.changePassword({ id: this.user.accountId, body })
        if (res.isSuccessful) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Thay đổi mật khẩu thành công',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$bvModal.hide('modal-change-password')
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },

    getFormattedDate(date) {
      return (date) ? moment(date).format('DD/MM/yyyy') : ''
    },
    showCurrencyVND(value) {
      // Create our number formatter.
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
      })

      return formatter.format(value)
    },

    async openPaymentTransaction() {
      this.isLoading = true
      try {
        const paymentUrl = await api.initiatePayment({ receiptId: this.studentInfoReception.id })
        if (paymentUrl) {
          window.location.href = paymentUrl
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
  },

}
</script>
